var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"container"}},[_c('div',{staticClass:"title"},[_vm._v("人车订单运单统计")]),_c('div',{attrs:{"id":"gauge-content"}},[_c('div',{ref:"gauge1_ref",attrs:{"id":"y_gauge1"}}),_c('div',{ref:"gauge2_ref",attrs:{"id":"y_gauge2"}}),_c('div',{ref:"gauge3_ref",attrs:{"id":"y_gauge3"}}),_c('div',{ref:"gauge4_ref",attrs:{"id":"y_gauge4"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }